import React, { Component } from 'react';
import {
  Row, Col, Card, CardBody, Button,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import Moment from 'moment';
import Dashboard from '../../../services/DashboardService';
import SalesGraph from './graph/SalesGraph';
import global from '../../../global';

class AdminDashboard extends Component {
  constructor() {
    super();
    this.currDate = new Date();
    this.state = {
      totalList: {},
      currentMonth: Moment(this.currDate).format('MMMM YYYY'),
      goTo: false,
      goToPage: '/',
    };
    this.isLoading = false;
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  componentWillMount() {
    this.isLoading = true;
    this.onLoadData();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  async onLoadData() {
    await Dashboard.admindashboard().then((response) => {
      const result = response;
      if (this.isLoading) {
        this.setState({ totalList: result });
      }
      this.isLoading = false;
    }).catch((error) => {
      console.log(error);
    });
  }

  goTo = (ev) => {
    this.setState({ goTo: true, goToPage: ev.currentTarget.dataset.href });
  }

  render() {
    const {
      totalList, currentMonth, goTo, goToPage,
    } = this.state;
    const salesGraph = totalList && totalList.sales_graph ? JSON.parse(totalList.sales_graph) : [];

    if (goTo === true) {
      return <Redirect to={{ pathname: goToPage, state: { prevpage: '/dashboard' } }} />;
    }

    return (
      <Row className="p-t-15" id="admin_dashboard">

        {
          this.userdata.type === '6' ? (
        <Col md={12}>
          <Row className="stock_top m-l-0 m-r-0">
            <Col md={6}>
              <div className="stock-box__container stock-lg">
                <Button className="stock-box stock-blue m-b-20 stock-block" onClick={this.goTo} data-href="/stockstracker/0/received/list">
                  <div className="stock-box__icon"><i className="fa fa-cube" /></div>
                  <h3 className="stock-box__num">Receiving Report</h3>
                  <h4 className="stock-box__text">{totalList && !Number.isNaN(totalList.receiving_report) && totalList.receiving_report > 0 ? parseFloat(totalList.receiving_report, 10).toLocaleString() : 0} kgs.</h4>
                </Button>
              </div>
            </Col>

            <Col md={6}>
              <div className="stock-box__container stock-lg">
                <div className="stock-box stock-green m-b-20 stock-block">
                  <div className="stock-box__icon"><i className="fa fa-cubes" /></div>
                  <h3 className="stock-box__num">Total Stock Balance</h3>
                  <h4 className="stock-box__text">{totalList && !Number.isNaN(totalList.stock_balance) && totalList.stock_balance > 0 ? parseFloat(totalList.stock_balance, 10).toLocaleString() : 0} kgs.</h4>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
          ) : ''
        }

        {
          this.userdata.type !== '6' ? (
        <Col md={12}>
          <Row className="stock_top m-l-0 m-r-0">
            <Col md={12}>

              <div className="stock-box__container stock-lg">
                <Button className="stock-box stock-aqua m-b-20" onClick={this.goTo} data-href="/stockstracker/0/stocksold/list">
                  <div className="stock-box__icon"><i className="fa fa-clipboard-list" /></div>
                  <h3 className="stock-box__num">Daily Sales</h3>
                  <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalList && !Number.isNaN(totalList.daily_sales) && totalList.daily_sales > 0 ? parseFloat(totalList.daily_sales, 10).toLocaleString() : 0.00}</h4>
                </Button>

                <Button className="stock-box stock-orange m-b-20" onClick={this.goTo} data-href="/report/receivables">
                  <div className="stock-box__icon"><i className="fa fa-coins" /></div>
                  <h3 className="stock-box__num">Total Receivables</h3>
                  <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalList && !Number.isNaN(totalList.total_receivables) && totalList.total_receivables > 0 ? parseFloat(totalList.total_receivables, 10).toLocaleString() : 0.00}</h4>
                </Button>

                <Button className="stock-box stock-pink m-b-20" onClick={this.goTo} data-href="/report/collections">
                  <div className="stock-box__icon"><i className="fa fa-money-bill-alt" /></div>
                  <h3 className="stock-box__num">Total Collection</h3>
                  <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalList && !Number.isNaN(totalList.total_collection) && totalList.total_collection > 0 ? parseFloat(totalList.total_collection, 10).toLocaleString() : 0.00}</h4>
                </Button>
              </div>

            </Col>
          </Row>
        </Col>
          ) : ''
        }

        {
          this.userdata.type !== '6' ? (
        <Col md={12}>
          <Row className="m-l-0 m-r-0">
            <Col md={12} lg={8} className="col-left">
              <Card className="border-top-primary">
                <CardBody className="p-20">
                  <div className="card__title">
                    <h5 className="bold-text text-aqua fs-17">Sales Graph <span className="text-green m-l-10">({currentMonth})</span></h5>
                  </div>
                  <div>
                    <SalesGraph
                      data={salesGraph}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={12} lg={4} className="col-right">
              <div className="stock-box__container stock-lg stock-block stock_magic">

              <Button className="stock-box stock-aqua m-b-20" onClick={this.goTo} data-href="/report/remits">
                <div className="stock-box__icon"><i className="fa fa-ruble-sign" /></div>
                <h3 className="stock-box__num">Total Remit</h3>
                <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalList && !Number.isNaN(totalList.total_remit) && totalList.total_remit > 0 ? parseFloat(totalList.total_remit, 10).toLocaleString() : 0.00}</h4>
              </Button>

              {
                this.userdata.type === '1' ? (
                  <>
                    <Button className="stock-box stock-green m-b-20" onClick={this.goTo} data-href="/report/profit">
                      <div className="stock-box__icon"><i className="fa fa-chart-line" /></div>
                      <h3 className="stock-box__num">Profit</h3>
                      <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalList && totalList.total_profit > 0 ? global.numberFormat(totalList.total_profit) : 0.00}</h4>
                    </Button>
                  </>
                ) : ''
              }

              <Button className="stock-box stock-blue m-b-20" onClick={this.goTo} data-href="/stockstracker/0/received/list">
                <div className="stock-box__icon"><i className="fa fa-cube" /></div>
                <h3 className="stock-box__num">Receiving Report</h3>
                <h4 className="stock-box__text">{totalList && !Number.isNaN(totalList.receiving_report) && totalList.receiving_report > 0 ? parseFloat(totalList.receiving_report, 10).toLocaleString() : 0} kgs.</h4>
              </Button>

              <div className="stock-box stock-green m-b-20">
                <div className="stock-box__icon"><i className="fa fa-cubes" /></div>
                <h3 className="stock-box__num">Total Stock Balance</h3>
                <h4 className="stock-box__text">{totalList && !Number.isNaN(totalList.stock_balance) && totalList.stock_balance > 0 ? parseFloat(totalList.stock_balance, 10).toLocaleString() : 0} kgs.</h4>
              </div>

              </div>
            </Col>
          </Row>
        </Col>
          ) : ''
        }
      </Row>
    );
  }
}

export default AdminDashboard;
